import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    standalone: false
})
export class ErrorDialogComponent implements OnInit {
    @Input() message: string;
    @Input() messageAlternative: string = '';
    constructor(private ngbActiveModal: NgbActiveModal) { }

    ngOnInit(): void { }
    closeModal() {
        this.ngbActiveModal.close(true);
    }
}
